export default "__VITE_ASSET__DDh9HzQx__"